export default {
    ENTITY_TOO_LARGE: 413,

    GENERIC_ERROR: 'GENERIC_ERROR',
    GENERAL_VALIDATION_ERROR: 'GENERAL_VALIDATION_ERROR',
    SYSTEM_CONFIGURATION_ERROR: 'SYSTEM_CONFIGURATION_ERROR',
    REPEATED_PASSWORD: 'REPEATED_PASSWORD',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    REPORT_NOT_GENERATED: 'REPORT_NOT_GENERATED',
    SAMPLE_UNDO_DISPOSAL_ERROR: 'SAMPLE_UNDO_DISPOSAL_ERROR',
    MAX_UPLOAD_SIZE_EXCEEDED: 'MAX_UPLOAD_SIZE_EXCEEDED',
    BAD_REQUEST: 'BAD_REQUEST',
    ASSOCIATED_SUBPORTIONS_FOUND: 'ASSOCIATED_SUBPORTIONS_FOUND',
    ASSOCIATED_PORTIONS_FOUND: 'ASSOCIATED_PORTIONS_FOUND',
    ASSOCIATED_SAMPLES_FOUND: 'ASSOCIATED_SAMPLES_FOUND',
    ASSOCIATED_CASES_FOUND: 'ASSOCIATED_CASES_FOUND',
    ASSOCIATED_REQUESTS_FOUND: 'ASSOCIATED_REQUESTS_FOUND',
    ASSOCIATED_INCIDENTS_FOUND: 'ASSOCIATED_INCIDENTS_FOUND',
    ASSOCIATED_ATTACHMENTS_FOUND: 'ASSOCIATED_ATTACHMENTS_FOUND',
    MARK_AS_DEPLETED_PORTION_HAS_SUBPORTIONS_PENDING_CUT: 'MARK_AS_DEPLETED_PORTION_HAS_SUBPORTIONS_PENDING_CUT',
    SAMPLE_HAS_PORTIONS_NOT_VERIFIED_AS_CLOSED: 'SAMPLE_HAS_PORTIONS_NOT_VERIFIED_AS_CLOSED',
    SAMPLE_MACRO_IS_MISSING: 'SAMPLE_MACRO_IS_MISSING',
    UNEXPECTED_SAMPLE_NUMBER: 'UNEXPECTED_SAMPLE_NUMBER',
    NO_MATCHING_REGEX: 'NO_MATCHING_REGEX',
    SAMPLE_INVALID_RESPONSIBLE_FOR_GROSSING: 'SAMPLE_INVALID_RESPONSIBLE_FOR_GROSSING',
    BATCH_PRINTING_OF_LABEL_NOT_FOUND_EXCEPTION: 'BATCH_PRINTING_OF_LABEL_NOT_FOUND_EXCEPTION',
    BATCH_PRINTING_TEMPLATE_DUPLICATED: 'BATCH_PRINTING_TEMPLATE_DUPLICATED',
    BATCH_PRINTING_TEMPLATE_MORE_THAN_ONE_MARKED_USED_BY_DEFAULT: 'BATCH_PRINTING_TEMPLATE_MORE_THAN_ONE_MARKED_USED_BY_DEFAULT',
    UNEXPECTED_REQUEST_CODE: 'UNEXPECTED_REQUEST_CODE',
    FILE_NOT_FOUND: 'FILE_NOT_FOUND',
    RECOVERY_EMAIL_NOT_FOUND: 'RECOVERY_EMAIL_NOT_FOUND',
    BAD_CREDENTIALS: 'BAD_CREDENTIALS',
    USER_ACCOUNT_LOCKED: 'USER_ACCOUNT_LOCKED',
    USER_CREDENTIALS_EXPIRED: 'USER_CREDENTIALS_EXPIRED',
    ACCESS_DENIED: 'ACCESS_DENIED',
    OPERATION_NOT_ALLOWED: 'OPERATION_NOT_ALLOWED',
    OPERATION_FORBIDDEN: 'OPERATION_FORBIDDEN',
    ENTITY_NOT_FOUND: 'ENTITY_NOT_FOUND',
    RESULT_LIMIT_EXCEEDED: 'RESULT_LIMIT_EXCEEDED',

    RELAUNCH_AUTOMATISMS_EXISTS_DO_NOT_APPLY_ANY: 'RELAUNCH_AUTOMATISMS_EXISTS_DO_NOT_APPLY_ANY',
    RELAUNCH_AUTOMATISMS_EXISTS_APPLY_WITHOUT_APPLYING_PREFORMATTED: 'RELAUNCH_AUTOMATISMS_EXISTS_APPLY_WITHOUT_APPLYING_PREFORMATTED',
    RELAUNCH_AUTOMATISMS_EXISTS_CANCEL: 'RELAUNCH_AUTOMATISMS_EXISTS_CANCEL',
    RELAUNCH_AUTOMATISMS_EXISTS_CANCEL_INCOMPLETE: 'RELAUNCH_AUTOMATISMS_EXISTS_CANCEL_INCOMPLETE',
    RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_WITHOUT_APPLYING_PREFORMATTED: 'RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_WITHOUT_APPLYING_PREFORMATTED',
    RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_APPLY_PREFORMATTED: 'RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_APPLY_PREFORMATTED',
    RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_AND_APPLY_PREFORMATTED: 'RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_AND_APPLY_PREFORMATTED',

    PREFORMATTED_CANNOT_ADD_SOME_SECTIONS: 'PREFORMATTED_CANNOT_ADD_SOME_SECTIONS',

    ADD_OR_REPLACE_CODIFICATIONS_WHEN_APPLYING_SYNOPTIC_TEMPLATE_EXCEPTION: 'ADD_OR_REPLACE_CODIFICATIONS_WHEN_APPLYING_SYNOPTIC_TEMPLATE_EXCEPTION',
    THERE_ARE_INCOMPATIBLE_SAMPLE_TYPES_WITH_THE_NEW_TYPE_OF_STUDY: 'THERE_ARE_INCOMPATIBLE_SAMPLE_TYPES_WITH_THE_NEW_TYPE_OF_STUDY',

    CONCURRENCY_ERROR: 'CONCURRENCY_ERROR',

    CASE_VALIDATION_ABORT: 'CASE_VALIDATION_ABORT',
    CASE_VALIDATION_WARNING: 'CASE_VALIDATION_WARNING',

    SHIPMENT_REQUEST_ERROR: 'SHIPMENT_REQUEST_ERROR',
    SHIPMENT_TYPE_AND_ENTITY_SHIPMENT_TYPE_ARE_DIFFERENT: 'SHIPMENT_TYPE_AND_ENTITY_SHIPMENT_TYPE_ARE_DIFFERENT',
    NO_ELEMENT_SELECTED: 'NO_ELEMENT_SELECTED',
    SHIPMENT_CONFIGURATION_ERROR: 'SHIPMENT_CONFIGURATION_ERROR',

    MORE_THAN_ONE_ASSAY_APPLIED_BY_AUTOMATISMS_TO_A_SAMPLE_ON_SLIDE: 'MORE_THAN_ONE_ASSAY_APPLIED_BY_AUTOMATISMS_TO_A_SAMPLE_ON_SLIDE'
}
